/**
 * Checks if there are any products in the cart.
 */
export default defineNuxtRouteMiddleware(() => {
    const cartStore = useCartStore();

    if (!cartStore.products.length) {
        return abortNavigation();
    }
});
